import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, ITeamViewState } from '../modules/teamView'

type IComponentProps = ITeamViewState &
  RouteComponentProps<{ id: string }> &
  typeof actionCreators

class TeamAccess extends React.PureComponent<IComponentProps> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div key={this.props.match.params.id}>
        <div className='mx-2'>{this._renderAccess()}</div>
      </div>
    )
  }

  private _renderAccess() {
    if (!this.props.item) {
      return null
    }

    if (
      !this.props.item.allowedAccessTo ||
      this.props.item.allowedAccessTo.size === 0
    ) {
      return 'No specific access rules applied'
    }

    const access = this.props.item.allowedAccessTo.map((item: any) => {
      return (
        <div
          key={item}
          style={{ borderBottom: '1px solid #ddd' }}
          className='d-flex flex-row flex-wrap justify-content-between mt-2'
        >
          <div>
            <strong>{item.name}</strong>
          </div>
          <div>{humanize(item.value)}</div>
        </div>
      )
    })

    return <div>{access}</div>
  }
}

export default withRouter(TeamAccess)
